import moment from 'utils/moment'

export function setTimezone (timezone) {
  moment.tz.setDefault(timezone)
}
